import { Typography, App } from 'antd';
import { CopyOutlined } from '@ant-design/icons';

/** 全局唯一资源 ID，可复制供 OpenAPI 按 ID 换取 URL。 */
export function ResourceID({ id }: { id?: string }) {
  const { message } = App.useApp();
  if (!id) {
    return <Typography.Text type="secondary">-</Typography.Text>;
  }
  return (
    <Typography.Text
      className="resource-id"
      copyable={{
        text: id,
        tooltips: ['复制资源 ID', '已复制'],
        icon: [<CopyOutlined key="c" />, <CopyOutlined key="d" />],
        onCopy: () => message.success('资源 ID 已复制'),
      }}
      style={{ fontSize: 12, fontFamily: 'ui-monospace, SFMono-Regular, Menlo, Consolas, monospace' }}
    >
      {id}
    </Typography.Text>
  );
}
